export default function setTitleAndMetaDescription(title: string, description?: string) {
    document.title = title

    const meta_og_title = document.querySelector('meta[property="og:title"]')
    if (meta_og_title != null) {
        meta_og_title.setAttribute("content", title);
    }

    if (description === undefined) {
        return
    }

    const meta_description = document.querySelector('meta[name="description"]')
    if (meta_description != null) {
        meta_description.setAttribute("content", description);
    }

    const meta_og_description = document.querySelector('meta[property="og:description"]')
    if (meta_og_description != null) {
        meta_og_description.setAttribute("content", description);
    }
}
